import classNames from 'classnames';

import styles from './HourGlass.module.css';

interface Props {
    className?: string;
    width?: string;
    height?: string;
}

export const HourGlass: React.FC<Props> = ({ className, width = '200', height = '200' }) => {
    return (
        <svg
            className={classNames(styles.spinner, className)}
            viewBox={'0 0 200 200'}
            width={width}
            height={height}
            preserveAspectRatio={'xMidYMid meet'}
            version={'1.1'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <defs>
                <clipPath id={'__lottie_element_2'}>
                    <rect width={'200'} height={'200'} x={'0'} y={'0'} />
                </clipPath>
                <clipPath id={'__lottie_element_4'}>
                    <path d={'M0,0 L200,0 L200,200 L0,200z'} />
                </clipPath>
                <mask id={'top-mask'}>
                    <rect x={'0'} y={'0'} width={'100'} height={'100'} fill={'white'} />
                    <rect x={'0'} y={'0'} width={'100'} height={'100'} fill={'black'}>
                        <animateTransform
                            id={'tmask'}
                            attributeName={'transform'}
                            type={'translate'}
                            from={'-50 50'}
                            to={'-50 0'}
                            begin={'0s'}
                            dur={'2s'}
                            repeatCount={'indefinite'}
                        />
                    </rect>
                </mask>
                <mask id={'bottom-mask'}>
                    <rect x={'0'} y={'0'} width={'100'} height={'100'} fill={'white'} />
                    <rect x={'0'} y={'0'} width={'100'} height={'100'} fill={'black'}>
                        <animateTransform
                            id={'bmask'}
                            attributeName={'transform'}
                            type={'translate'}
                            from={'-50 0'}
                            to={'-50 50'}
                            begin={'0s'}
                            dur={'2s'}
                            repeatCount={'indefinite'}
                        />
                    </rect>
                </mask>
            </defs>
            <g clipPath={'url(#__lottie_element_2)'}>
                <animateTransform
                    id={'arotate'}
                    attributeName={'transform'}
                    type={'rotate'}
                    from={'0 100 100'}
                    to={'180 100 100'}
                    begin={'1s;arotate.end+1s'}
                    dur={'1s'}
                />

                <g
                    clipPath={'url(#__lottie_element_4)'}
                    style={{ display: 'block' }}
                    transform={'matrix(-1,0,0,-1,200,200)'}
                    opacity={'1'}
                    id={'g178'}
                >
                    <g
                        style={{ display: 'block' }}
                        transform={'matrix(1,0,0,1,68.46299743652344,35.5)'}
                        opacity={'1'}
                        id={'g128'}
                    >
                        <g opacity={'1'} transform={'matrix(1,0,0,1,0,0)'} id={'g126'}>
                            <path
                                strokeLinecap={'round'}
                                strokeLinejoin={'round'}
                                fillOpacity={'0'}
                                stroke={'rgb(59,70,78)'}
                                strokeOpacity={'1'}
                                strokeWidth={'2'}
                                d={' M1,1 C1,1 59.68600082397461,1 59.68600082397461,1'}
                                id={'path124'}
                            />
                        </g>
                    </g>
                    <g
                        style={{ display: 'block' }}
                        transform={'matrix(1,0,0,1,68.46299743652344,162.8820037841797)'}
                        opacity={'1'}
                        id={'g134'}
                    >
                        <g opacity={'1'} transform={'matrix(1,0,0,1,0,0)'} id={'g132'}>
                            <path
                                strokeLinecap={'round'}
                                strokeLinejoin={'round'}
                                fillOpacity={'0'}
                                stroke={'rgb(59,70,78)'}
                                strokeOpacity={'1'}
                                strokeWidth={'2'}
                                d={' M59.68600082397461,1 C59.68600082397461,1 1,1 1,1'}
                                id={'path130'}
                            />
                        </g>
                    </g>
                    <g
                        style={{ display: 'block' }}
                        transform={'matrix(1,0,0,1,98.4469985961914,42.24799728393555)'}
                        opacity={'1'}
                        id={'g140'}
                    >
                        <g opacity={'1'} transform={'matrix(1,0,0,1,16.041000366210938,57.9379997253418)'} id={'g138'}>
                            <path
                                strokeLinecap={'round'}
                                strokeLinejoin={'round'}
                                fillOpacity={'0'}
                                stroke={'rgb(59,70,78)'}
                                strokeOpacity={'1'}
                                strokeWidth={'2'}
                                d={
                                    ' M5.5,55.9379997253418 C5.5,55.9379997253418 9.939000129699707,38.71799850463867 9.939000129699707,38.71799850463867 C14.041000366210938,22.660999298095703 3.7880001068115234,6.144999980926514 -12.616000175476074,3.3580000400543213 C-13.07699966430664,3.2769999504089355 -13.548999786376953,3.2060000896453857 -14.041000366210938,3.1440000534057617 C-14.041000366210938,3.1440000534057617 -14.041000366210938,-3.134000062942505 -14.041000366210938,-3.134000062942505 C-14.041000366210938,-3.134000062942505 -12.616000175476074,-3.3480000495910645 -12.616000175476074,-3.3480000495910645 C3.7880001068115234,-6.144999980926514 14.041000366210938,-22.660999298095703 9.939000129699707,-38.71799850463867 C9.939000129699707,-38.71799850463867 5.5,-55.9379997253418 5.5,-55.9379997253418'
                                }
                                id={'path136'}
                            />
                        </g>
                    </g>
                    <g
                        style={{ display: 'block' }}
                        transform={'matrix(1,0,0,1,67.24800109863281,42.24799728393555)'}
                        opacity={'1'}
                        id={'g146'}
                    >
                        <g opacity={'1'} transform={'matrix(1,0,0,1,16.04199981689453,57.9379997253418)'} id={'g144'}>
                            <path
                                strokeLinecap={'round'}
                                strokeLinejoin={'round'}
                                fillOpacity={'0'}
                                stroke={'rgb(59,70,78)'}
                                strokeOpacity={'1'}
                                strokeWidth={'2'}
                                d={
                                    ' M-5.500999927520752,-55.9379997253418 C-5.500999927520752,-55.9379997253418 -9.939000129699707,-38.71799850463867 -9.939000129699707,-38.71799850463867 C-14.041000366210938,-22.660999298095703 -3.7890000343322754,-6.144999980926514 12.614999771118164,-3.3480000495910645 C12.614999771118164,-3.3480000495910645 14.041999816894531,-3.134000062942505 14.041999816894531,-3.134000062942505 C14.041999816894531,-3.134000062942505 14.041999816894531,3.1440000534057617 14.041999816894531,3.1440000534057617 C13.548999786376953,3.2060000896453857 13.07699966430664,3.2769999504089355 12.614999771118164,3.3580000400543213 C-3.7890000343322754,6.144999980926514 -14.041000366210938,22.660999298095703 -9.939000129699707,38.71799850463867 C-9.939000129699707,38.71799850463867 -5.500999927520752,55.9379997253418 -5.500999927520752,55.9379997253418'
                                }
                                id={'path142'}
                            />
                        </g>
                    </g>
                    <g
                        style={{ display: 'block' }}
                        transform={'matrix(1,0,0,1,61.875003814697266,42.257999420166016)'}
                        opacity={'1'}
                        id={'g152'}
                    >
                        <g opacity={'1'} transform={'matrix(1,0,0,1,36.81399917602539,57.92300033569336)'} id={'g150'}>
                            <path
                                strokeLinecap={'round'}
                                strokeLinejoin={'round'}
                                fillOpacity={'0'}
                                stroke={'rgb(59,70,78)'}
                                strokeOpacity={'1'}
                                strokeWidth={'2'}
                                d={
                                    ' M29.21500015258789,55.92300033569336 C29.21500015258789,55.92300033569336 34.1879997253418,19.992000579833984 34.1879997253418,19.992000579833984 C34.814998626708984,15.437999725341797 34.321998596191406,10.800999641418457 32.755001068115234,6.4770002365112305 C31.187000274658203,2.1530001163482666 28.59000015258789,-1.7269999980926514 25.18600082397461,-4.833000183105469 C25.18600082397461,-4.833000183105469 24.4060001373291,-5.547999858856201 24.4060001373291,-5.547999858856201 C23.87299919128418,-6.0329999923706055 23.19300079345703,-6.326000213623047 22.472999572753906,-6.385000228881836 C21.753000259399414,-6.443999767303467 21.034000396728516,-6.264999866485596 20.42799949645996,-5.874000072479248 C19.961999893188477,-5.579999923706055 19.57900047302246,-5.173999786376953 19.31399917602539,-4.692999839782715 C19.04800033569336,-4.211999893188477 18.908000946044922,-3.6730000972747803 18.908000946044922,-3.124000072479248 C18.908000946044922,-2.575000047683716 19.04800033569336,-2.0339999198913574 19.31399917602539,-1.5529999732971191 C19.57900047302246,-1.0720000267028809 19.961999893188477,-0.6660000085830688 20.42799949645996,-0.3720000088214874 C21.02400016784668,0.004999999888241291 21.72800064086914,0.18000000715255737 22.43199920654297,0.12700000405311584 C23.13599967956543,0.0729999989271164 23.804000854492188,-0.20600000023841858 24.334999084472656,-0.6690000295639038 C27.97800064086914,-3.819999933242798 30.756000518798828,-7.839000225067139 32.41299819946289,-12.350000381469727 C34.069000244140625,-16.861000061035156 34.55099868774414,-21.718000411987305 33.808998107910156,-26.464000701904297 C33.808998107910156,-26.464000701904297 29.21500015258789,-55.92300033569336 29.21500015258789,-55.92300033569336 C29.21500015258789,-55.92300033569336 29.216999053955078,-55.92300033569336 29.216999053955078,-55.92300033569336 C29.216999053955078,-55.92300033569336 -29.225000381469727,-55.92300033569336 -29.225000381469727,-55.92300033569336 C-29.225000381469727,-55.92300033569336 -33.808998107910156,-26.464000701904297 -33.808998107910156,-26.464000701904297 C-34.55099868774414,-21.718000411987305 -34.06999969482422,-16.861000061035156 -32.41299819946289,-12.350000381469727 C-30.756000518798828,-7.839000225067139 -27.976999282836914,-3.819999933242798 -24.334999084472656,-0.6690000295639038 C-23.80299949645996,-0.20600000023841858 -23.13599967956543,0.0729999989271164 -22.43199920654297,0.12700000405311584 C-21.72800064086914,0.18000000715255737 -21.024999618530273,0.004999999888241291 -20.43000030517578,-0.3720000088214874 C-19.964000701904297,-0.6660000085830688 -19.579999923706055,-1.0720000267028809 -19.31399917602539,-1.5529999732971191 C-19.04800033569336,-2.0339999198913574 -18.909000396728516,-2.575000047683716 -18.909000396728516,-3.124000072479248 C-18.909000396728516,-3.6730000972747803 -19.04800033569336,-4.211999893188477 -19.31399917602539,-4.692999839782715 C-19.579999923706055,-5.173999786376953 -19.964000701904297,-5.579999923706055 -20.43000030517578,-5.874000072479248 C-21.035999298095703,-6.264999866485596 -21.753999710083008,-6.443999767303467 -22.472999572753906,-6.385000228881836 C-23.19300079345703,-6.326000213623047 -23.87299919128418,-6.0329999923706055 -24.408000946044922,-5.547999858856201 C-24.408000946044922,-5.547999858856201 -25.18600082397461,-4.833000183105469 -25.18600082397461,-4.833000183105469 C-28.590999603271484,-1.7269999980926514 -31.187000274658203,2.1530001163482666 -32.755001068115234,6.4770002365112305 C-34.323001861572266,10.800999641418457 -34.814998626708984,15.437999725341797 -34.1879997253418,19.992000579833984 C-34.1879997253418,19.992000579833984 -29.21500015258789,55.92300033569336 -29.21500015258789,55.92300033569336 C-29.21500015258789,55.92300033569336 29.21500015258789,55.92300033569336 29.21500015258789,55.92300033569336z'
                                }
                                id={'path148'}
                            />
                        </g>
                    </g>
                    {/* this is the wine in the top glass */}
                    <g
                        mask={'url(#top-mask)'}
                        style={{ display: 'block' }}
                        transform={'matrix(1,0,0,1,77.62699890136719,108.63200378417969)'}
                        opacity={'1'}
                        id={'g158'}
                    >
                        <g opacity={'1'} transform={'matrix(1,0,0,1,21.25,21.25)'} id={'g156'}>
                            <path
                                fill={'rgb(238,217,216)'}
                                fillOpacity={'1'}
                                d={
                                    ' M0,-21 C-11.597999572753906,-21 -21,-11.385000228881836 -21,0.4779999852180481 C-21,12.33899974822998 -16.33300018310547,21 -16.33300018310547,21 C-16.33300018310547,21 17.267000198364258,21 17.267000198364258,21 C17.267000198364258,21 21,12.33899974822998 21,0.4779999852180481 C21,-11.385000228881836 11.598999977111816,-21 0,-21z'
                                }
                                id={'path154'}
                            />
                        </g>
                    </g>
                    {/* this is the wine in the bottom glass */}
                    <g
                        style={{ display: 'block' }}
                        transform={'rotate(-180,60.019822,45.806277)'}
                        opacity={'1'}
                        mask={'url(#bottom-mask)'}
                    >
                        <g opacity={'1'} transform={'translate(21.25,21.25)'}>
                            <path
                                fill={'#eed9d8'}
                                fillOpacity={'1'}
                                d={
                                    'm 0,-21 c -11.598,0 -21,9.615 -21,21.47799999 C -21,12.339 -17.345283,18.697263 -17.345283,18.697263 l 35.257921,0.323121 C 17.912638,19.020384 21,12.339 21,0.47799999 21,-11.385 11.599,-21 0,-21 Z'
                                }
                            />
                        </g>
                    </g>

                    <g
                        style={{ display: 'block' }}
                        transform={'matrix(1,0,0,1,88.58699798583984,136.49600219726562)'}
                        opacity={'1'}
                    >
                        <g opacity={'1'} transform={'matrix(1,0,0,1,18.5,10.692999839782715)'} id={'g168'}>
                            <path
                                strokeLinecap={'round'}
                                strokeLinejoin={'round'}
                                fillOpacity={'0'}
                                stroke={'rgb(59,70,78)'}
                                strokeOpacity={'1'}
                                strokeWidth={'2'}
                                d={
                                    ' M16.5,-5.02400016784668 C16.5,-5.02400016784668 13.541999816894531,-1.3639999628067017 10.0600004196167,-4.131999969482422 C9.616999626159668,-4.494999885559082 9.210000038146973,-4.9019999504089355 8.847000122070312,-5.3470001220703125 C6.071000099182129,-8.692999839782715 4.383999824523926,-2.4079999923706055 1.565999984741211,0.012000000104308128 C1.0169999599456787,0.5210000276565552 0.31299999356269836,0.8209999799728394 -0.42800000309944153,0.8619999885559082 C-0.9980000257492065,0.8349999785423279 -1.5579999685287476,0.6899999976158142 -2.071000099182129,0.4359999895095825 C-2.5859999656677246,0.18199999630451202 -3.0450000762939453,-0.17599999904632568 -3.4189999103546143,-0.6159999966621399 C-7.2170000076293945,-4.302000045776367 -9.677000045776367,0.828000009059906 -12.062000274658203,4.870999813079834 C-13.034000396728516,6.656000137329102 -14.61299991607666,8.015999794006348 -16.5,8.692999839782715'
                                }
                                id={'path166'}
                            />
                        </g>
                    </g>
                    <g style={{ display: 'block' }} transform={'matrix(1,0,0,1,72.5,42.5)'} opacity={'1'}>
                        <g opacity={'1'} transform={'matrix(1,0,0,1,18.5,10.692999839782715)'}>
                            <path
                                strokeLinecap={'round'}
                                strokeLinejoin={'round'}
                                fillOpacity={'0'}
                                stroke={'rgb(59,70,78)'}
                                strokeOpacity={'1'}
                                strokeWidth={'2'}
                                d={
                                    ' M-16.5,5.02400016784668 C-16.5,5.02400016784668 -13.541999816894531,1.3630000352859497 -10.0600004196167,4.131999969482422 C-9.616000175476074,4.49399995803833 -9.210000038146973,4.901000022888184 -8.845999717712402,5.3470001220703125 C-6.071000099182129,8.692999839782715 -4.383999824523926,2.4079999923706055 -1.565999984741211,-0.013000000268220901 C-1.0169999599456787,-0.5210000276565552 -0.31299999356269836,-0.8209999799728394 0.42800000309944153,-0.8619999885559082 C0.9990000128746033,-0.8349999785423279 1.5579999685287476,-0.6909999847412109 2.072000026702881,-0.43700000643730164 C2.5859999656677246,-0.18299999833106995 3.0450000762939453,0.17499999701976776 3.4200000762939453,0.6159999966621399 C7.2170000076293945,4.302000045776367 9.678000450134277,-0.828000009059906 12.062000274658203,-4.870999813079834 C13.034000396728516,-6.6570000648498535 14.61299991607666,-8.017000198364258 16.5,-8.692999839782715'
                                }
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
